export default __webpack_public_path__ + "static/logo_dark-194d8aae1b34486432d8346e1fbea5de.svg";